import React, { useState } from "react";

import Modal from "react-modal";
import Swal from "sweetalert2";
import { FaTrashAlt, FaEdit } from 'react-icons/fa';
import { IconContext } from 'react-icons';
import "./TablaProductos.css";
Modal.setAppElement('#root');

const TablaProductos = (props) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [cantidad, setCantidad] = useState(0);
  const [precioUnitario, setPrecioUnitario] = useState(0);
  const [porcentajeDescuento, setPorcentajeDescuento] = useState(0);
  const [vinSerie, setVinSerie] = useState('');
  const [indexL, setIndexL] = useState(0);

  const openModal = (producto, index) => {
    setSelectedProduct(producto);
    setCantidad(producto.Cantidad);
    setPrecioUnitario(producto.Price);
    setPorcentajeDescuento(producto.PorcentajeDescuento);
    setVinSerie(producto.NumeroVINoSerie || '');
    setIndexL(index);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedProduct(null);
  };

  const customStyles = {
    content: {
      top: '30%',
      left: '45%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: '#e7ecf0',
      borderTop: '#e09d00 solid 3px'
    },
  };
  const handleSave = () => {
    if (precioUnitario < 0 || cantidad < 0 || porcentajeDescuento < 0) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Los valores no pueden ser negativos',
      });

      return;
    }
    props.ActualizarDetalleLinea(indexL, precioUnitario, porcentajeDescuento, cantidad, vinSerie);
    closeModal();
  };

  const handleDelete = () => {
    props.EliminarDetalleLinea(indexL);
    closeModal();
  };
  const eliminarProducto = (index) => {
    props.EliminarDetalleLinea(index);
  }

  return (
    <div className="tabla-productos-container">
      <table className="tabla-productos dptable">
        <thead>
          <tr>
            <th style={{ backgroundColor: "#007f5f" }}>Código</th>
            <th style={{ backgroundColor: "#007f5f" }}>Nombre</th>
            <th className="dptd" style={{ backgroundColor: "#007f5f" }}>Cantidad</th>
            <th className="dptd" style={{ backgroundColor: "#007f5f" }}>Precio Unit</th>
            <th className="dptd" style={{ backgroundColor: "#007f5f" }}>IVA</th>
            <th className="dptd" style={{ backgroundColor: "#007f5f" }}>Total</th>
            <th className="dpth" style={{ backgroundColor: "#007f5f" }}>Opciones</th>
          </tr>
        </thead>
        <tbody>
          {props.Gestor.DetalleLineas.map((producto, index) => (
            <tr key={index}>
              <td>{producto.ItemCode}</td>
              <td>{producto.Detalle}</td>
              <td className="dpth">{producto.Cantidad.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
              <td className="dpth">{producto.PrecioUnitario.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
              <td className="dpth">{producto.Tarifa}</td>
              <td className="dpth">{producto.TotalComprobante.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
              <IconContext.Provider value={{ className: 'react-icons', size: '1.3em' }}>
                <td>
                  <div className="acciones">
                    <button className="icon-btn edit-btn" onClick={() => openModal(producto, index)} title="Editar">
                      <FaEdit style={{ opacity: 1,fill: '#3498db ', strokeWidth: 20  }}  />
                    </button>
                    <button className="icon-btn delete-btn" onClick={() => eliminarProducto(index)} title="Eliminar">
                      <FaTrashAlt style={{ opacity: 1,fill: '#c0392b ', strokeWidth: 20  }} />
                    </button>
                  </div>
                </td>
              </IconContext.Provider>
            </tr>
          ))}
        </tbody>
      </table>


      {selectedProduct && (
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          ariaHideApp={false}
          size='sm'
          className={'mymodalAgregarLineaArticulo'}
          style={customStyles}
        >
          <h5 style={{ backgroundColor: '#019688', color: 'black', margin: '0px', padding: '8px' }}>{selectedProduct.Detalle}</h5>
          <div style={{ marginLeft: '15px', marginTop: '5px' }}>
            <div className="row">
              <div className="col-50" style={{ padding: '0 10px' }}>
                <label>Cantidad: </label>
              </div>
              <div className="col-50" style={{ padding: '0 10px' }}>
                <input
                  type="number"
                  value={cantidad}
                  onChange={(e) => setCantidad(e.target.value)}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-50" style={{ padding: '0 10px' }}>
                <label>Precio Unitario: </label>
              </div>
              <div className="col-50" style={{ padding: '0 10px' }}>
                <input
                  type="number"
                  value={precioUnitario}
                  onChange={(e) => setPrecioUnitario(e.target.value)}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-50" style={{ padding: '0 10px' }}>
                <label>Porcentaje Descuento: </label>
              </div>
              <div className="col-50" style={{ padding: '0 10px' }}>
                <input
                  type="number"
                  value={porcentajeDescuento}
                  onChange={(e) => setPorcentajeDescuento(e.target.value)}
                />
              </div>
            </div>

            <div className="row">
  <div className="col-100" style={{ padding: '0 10px' }}>
    <label>N° VIN o Serie:</label>
    <input
      type="text"
      value={vinSerie}
      style={{ width: '50%', display: 'block', marginTop: '5px' }}
      onChange={(e) => setVinSerie(e.target.value)}
    />
  </div>
</div>


            <br />
            <div className="row">
              <div className="col-25">
                <button style={{ width: '90%' }} onClick={handleSave}>Guardar</button>
              </div>
              <div className="col-25">
                <button style={{ width: '90%' }} onClick={handleDelete}>Eliminar</button>
              </div>
              <div className="col-25">
                <button style={{ width: '90%' }} onClick={closeModal}>Cancelar</button>
              </div>
              <div className="col-25">
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default TablaProductos;